
import { defineComponent } from 'vue'
import DocumentBrowserBreadcrumb from './breadcrumbs/DocumentBrowserBreadcrumb.vue'
import DocumentBrowserTable from './tables/DocumentBrowserTable.vue'
import DocumentBrowserSidebar from './sidebar/DocumentBrowserSidebar.vue'

export default defineComponent({
    name: 'document-browser-detail',
    components: { DocumentBrowserBreadcrumb, DocumentBrowserTable, DocumentBrowserSidebar },
    props: { propDocuments: { type: Array }, breadcrumbs: { type: Array }, searchMode: { type: Boolean } },
    emits: ['breadcrumbClicked', 'loading', 'documentCloned', 'itemSelected', 'documentStateChanged', 'showDocumentDetails'],
    data() {
        return {
            documents: [] as any[],
            selectedDocument: null as any
        }
    },
    watch: {
        propDocuments() {
            this.loadDocuments()
            this.selectedDocument = null
        }
    },
    created() {
        this.loadDocuments()
    },
    methods: {
        loadDocuments() {
            this.documents = this.propDocuments as any[]
        },
        setSelectedDocument(document: any) {
            this.selectedDocument = document
        },
        async cloneDocument(document: any) {
            this.$emit('loading', true)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `documents/clone?docId=${document.id}`)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.createTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.$emit('documentCloned')
                })
                .catch(() => {})
            this.$emit('loading', false)
        },
        async deleteDocument(document: any) {
            this.$emit('loading', true)
            await this.$http
                .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/documents/${document.label}`)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.selectedDocument = null
                    this.documents = this.documents.filter((el: any) => el.id !== document.id)
                })
                .catch(() => {})
            this.$emit('loading', false)
        },
        async changeDocumentState(event: any) {
            this.$emit('loading', true)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `documents/changeStateDocument?docId=${event.document.id}&direction=${event.direction}`)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.$emit('documentStateChanged')
                })
                .catch(() => {})
            this.$emit('loading', false)
        }
    }
})
